import React, { useEffect, useState } from 'react'
import SessionError from './sessionerror';
import { addEventListeners, removeEventListeners } from '../../../utils/eventlistenerUtil'
import helperfunctions from '../../../utils/helperfunctions';
import { selectors as headerSelector } from "../../../state/features/header";
import { useSelector } from "react-redux";

const SessionErrorContainer = (props:any) => {
    const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
    const { headercurrentuser: { azureADId } }: any = useSelector((state) => ({
        headercurrentuser: headerSelector.currentuser(state),
    }));
    useEffect(() => {
        const createTimeout1 = () => setTimeout(() => {
            setIsWarningModalOpen(true);
        }, props?.sessionTimeOut)

        const createTimeout2 = () => setTimeout(() => {
            helperfunctions.setDefaultUserSessionForShoppingCart(azureADId);
            window.location.href = "/auth/logout?isSessionExpired=true"
        }, 60000)

        const listener = () => {
            if (!isWarningModalOpen) {
                clearTimeout(timeout)
                timeout = createTimeout1();
            }
        }
        // Initialization
        let timeout = isWarningModalOpen ? createTimeout2() : createTimeout1()
        addEventListeners(listener);

        // Cleanup
        return () => {
            removeEventListeners(listener);
            clearTimeout(timeout);
        }
    }, [isWarningModalOpen])

    const onLogOffCall = () => {
        helperfunctions.setDefaultUserSessionForShoppingCart(azureADId);
        window.location.href = "/auth/logout"
    }
    return ( 
         <div>
            {isWarningModalOpen && (
                <SessionError onRequestClose={() => setIsWarningModalOpen(false)} onLogOffCall={onLogOffCall }                
                />
            )
            }
        </div>  
    );
}
 
export default SessionErrorContainer;